var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { useInView } from "react-intersection-observer";
var placeholderSrc = function (_a) {
    var width = _a[0], height = _a[1];
    return "data:image/svg+xml,%3Csvg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 ".concat(width, " ").concat(height, "\"%3E%3C/svg%3E");
};
var lazyOptions = {
    triggerOnce: true,
    rootMargin: "300px 0px",
};
export default (function (_a) {
    var children = _a.children, placeholder = _a.placeholder, style = _a.style, rest = __rest(_a, ["children", "placeholder", "style"]);
    var _b = useInView(lazyOptions), ref = _b[0], inView = _b[1];
    return (React.createElement("div", { ref: ref, style: style }, inView ? (React.createElement("video", __assign({}, rest, { style: __assign({ width: "100%" }, style) }), children)) : placeholder ? (React.createElement("img", { alt: "Loading", src: placeholderSrc(placeholder), width: placeholder[0], height: placeholder[1], style: { width: "100%", height: "auto", display: "block" } })) : null));
});
//# sourceMappingURL=Video.js.map